<template>
  <apexchart :options="options" :series="series"></apexchart>
</template> 

<script>
import VueApexCharts from "vue3-apexcharts";
import { useViewSelector } from "../../stores/viewSelector";
import { useUserStore } from '../../stores/user';
import { storeToRefs } from 'pinia';
export default{
  name: 'barChart',
  components:{
    apexchart: VueApexCharts,
  },
  setup() {
    const viewSelector = useViewSelector();
    const {currentView} = storeToRefs(viewSelector);
    
    const userStore = useUserStore();
    const {user_id, comp_id, isSessionExpired} = storeToRefs(userStore);
    const { trigSessVerify } = userStore;

    return {
      user_id,
      comp_id,
      currentView,      
      isSessionExpired,
      trigSessVerify,
    }
  },
  data(){
    return {
      options: {
        chart: {
          type:'bar',
          id: 'vueMrrMovementBarChart',
          stacked: true,
          width:'100%',
        },
        colors:['#7789A4','#0B9719','#BA2D0D'],
        xaxis: {
          type:'datetime',
          categories:[],
        },
        dataLabels:{
          enabled:false,
        },
        title: {
          text: "MRR Movement",
        },
        responsive: [
          {
            breakpoint: 640,
            options: {
              chart: {
                toolbar: {
                  tools: {
                    zoom: false,
                    zoomin: false,
                    zoomout: false,
                    pan: false,
                    reset: false,
                  }
                },
              },
            }
          }
        ]
      },
      plotOptions: {
        bar: {
          horizontal: false,
          borderRadius: 10,
        },
      },
      noData:{
        text:'Loading...',
      },
      legend: {
        position: 'right',
        offsetY: 40,
      },
      series: [{
            name: 'MRR',
            data: []
          }, {
            name: 'Novos Clientes',
            data: []
          }, {
            name: 'Churn',
            data: []
          },
      ],
    }
  },  
  
  computed: {
    translation: function() {
      return ({
        series: [this.$i18n.t("graphs.barStackNeg.series[0]"), this.$i18n.t("graphs.barStackNeg.series[1]")],
      })
    }
  },
  watch: {
    translation(t) {
      this.series[0].name = t.series[0];
      this.series[1].name = t.series[1];
    }
  },
    
  mounted() {

    let url = process.env.VUE_APP_URL + '/mrrmovement';
    console.log('NAMEEEEEEEEEEE:'+this.$options.name)
    let nB = {u_id:this.user_id ,c_id:this.comp_id }
    fetch(url, {
      method:'POST',
      body:JSON.stringify(nB),
      headers: new Headers({
        "content-type":"application/json"
      })
    })
    .then((res) => res.json())
    .then((content) => {
      console.table(content);
      if(content.invalidSession){
        this.currentView = 'Login';
      }else{
        // MANDAR O MONTHLY DATE EM APENAS UM DOS OBJETOS
        // console.log('new bar: '+JSON.stringify(content));
        let w = [].concat(...content.mrrMove[0].chart_data.MRR).map(({monthly_date})=>monthly_date);     
        let x = [].concat(...content.mrrMove[0].chart_data.MRR).map(({value})=>value);
        let y = [].concat(...content.mrrMove[0].chart_data.New_customers).map(({value})=>value);
        let z = [].concat(...content.mrrMove[0].chart_data.Churn).map(({value})=>value);
        this.options = {
        ...this.options,
        ...{
            xaxis:{
              categories: w
            }
          }
        }
        this.series[0].data = x;
        this.series[1].data = y;
        this.series[2].data = z;

        this.series[0].name = this.translation.series[0];
        this.series[1].name = this.translation.series[1];
      }
    })
    .catch((err) => {console.log('Erro, '+err)}); 
    
  },
}
</script>


<style>
  .wrap {
    display: flex;
    justify-content: center;
}
</style>
